/** 分转元展示 */
export const fenToYuanText = (fen) => {
  if (fen == null || Number.isNaN(Number(fen))) return null
  return (Number(fen) / 100).toFixed(1)
}

/**
 * 订单列表票价列展示行
 * @returns {Array<{ label: string, value: string, highlight?: boolean }>}
 */
export const buildOrderPriceLines = (record) => {
  const lines = []
  const status = record?.passengerStatus ?? record?.status
  const isRefunding = [40, 41].includes(Number(status))

  if (isRefunding) {
    const ticketYuan = fenToYuanText(record?.amount)
    if (ticketYuan != null) {
      lines.push({ label: '原车票价', value: `¥${ticketYuan}` })
    }
    const serviceFeeYuan = fenToYuanText(record?.refundFee)
    if (serviceFeeYuan != null) {
      lines.push({ label: '收取退票服务费', value: `¥${serviceFeeYuan}` })
    }
    const railwayFeeYuan = fenToYuanText(record?.railwayRefundFee)
    if (railwayFeeYuan != null) {
      lines.push({ label: '收取退票费', value: `¥${railwayFeeYuan}` })
    }
    const refundYuan = fenToYuanText(record?.ticketRefundAmount)
    if (refundYuan != null) {
      lines.push({ label: '退款金额', value: `¥${refundYuan}`, highlight: true })
    }
    return lines
  }

  const ticketYuan = fenToYuanText(record?.amount)
  if (ticketYuan != null) {
    lines.push({ label: '车票价', value: `¥${ticketYuan}` })
  }
  const hasRescheduleFee =
    record?.oldTicketPrice != null ||
    record?.rescheduleFee != null ||
    record?.rescheduleServiceFee != null ||
    record?.reschedulePayAmount != null ||
    (record?.refundAmount != null && Number(record.refundAmount) > 0)

  if (hasRescheduleFee) {
    const oldYuan = fenToYuanText(record?.oldTicketPrice)
    if (oldYuan != null) {
      lines.push({ label: '原票价', value: `¥${oldYuan}` })
    }
    const feeYuan = fenToYuanText(record?.rescheduleFee)
    if (feeYuan != null) {
      lines.push({ label: '改签手续费', value: `¥${feeYuan}` })
    }
    const serviceFeeYuan = fenToYuanText(record?.rescheduleServiceFee)
    if (serviceFeeYuan != null) {
      lines.push({ label: '改签服务费', value: `¥${serviceFeeYuan}` })
    }
    const payYuan = fenToYuanText(record?.reschedulePayAmount)
    const refundYuan = fenToYuanText(record?.refundAmount)
    if (payYuan != null && Number(record.reschedulePayAmount) > 0) {
      lines.push({ label: '改签支付', value: `¥${payYuan}`, highlight: true })
    } else if (refundYuan != null && Number(record.refundAmount) > 0) {
      lines.push({ label: '退款金额', value: `¥${refundYuan}`, highlight: true })
    }
  }

  return lines
}
